import { OnInit } from '@angular/core';
import { AnnouncementService } from '../services/announcement.service';
var AnnouncementBarComponent = /** @class */ (function () {
    function AnnouncementBarComponent(announcementService) {
        this.announcementService = announcementService;
    }
    AnnouncementBarComponent.prototype.ngOnInit = function () {
        var _this = this;
        // for now we are just going to grab a new announcement every time we come to the client list page.
        this.announcementService.getAnnouncements()
            .then(function (announcements) {
            _this._announcements = announcements.map(function (a) {
                a.alertClass = 'alert-' + a.type;
                return a;
            });
        })
            .catch(function (error) {
            console.error(error);
        });
    };
    Object.defineProperty(AnnouncementBarComponent.prototype, "Announcements", {
        get: function () {
            return this._announcements;
        },
        enumerable: true,
        configurable: true
    });
    AnnouncementBarComponent.prototype.dismissAnnouncement = function (announcement) {
        this._announcements = this._announcements.filter(function (a) { return a !== announcement; });
        this.announcementService.markAnnouncementRead(announcement); // even if it fails it will show up the next time and we take care of it on the server.
    };
    return AnnouncementBarComponent;
}());
export { AnnouncementBarComponent };



// WEBPACK FOOTER //
// ./src/app/admin/announcement-bar/announcement-bar.component.ts.pre-build-optimizer.js